import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b2c2d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-help-link" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#AFB7BD",
    d: "M11.405 21.718c-5.777 0-10.478-4.7-10.478-10.478S5.628.762 11.405.762c5.778 0 10.478 4.7 10.478 10.478s-4.7 10.478-10.478 10.478zm0-19.423c-4.932 0-8.944 4.012-8.944 8.945 0 4.932 4.012 8.944 8.944 8.944 4.932 0 8.945-4.012 8.945-8.944 0-4.933-4.013-8.945-8.945-8.945zm-.379 12.509c-.335.138-.716.27-1.075.27-.275 0-.536-.078-.75-.289-.166-.164-.606-.599-.607-3.468-.001-3.031.457-3.483.607-3.632.537-.528 1.406-.165 1.778-.01.531.222 4.26 2.133 4.26 3.565 0 1.334-3.356 3.205-4.213 3.564zm-.761-5.775c-.181 1.021-.184 3.467-.003 4.438.897-.318 2.839-1.594 3.364-2.226-.52-.614-2.44-1.867-3.361-2.212z"
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "w-100",
  controls: "controls",
  ref: "videoRef",
  autoplay: ""
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode("   " + _toDisplayString(_ctx.title) + ": ", 1),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
      target: "_blank",
      class: "video-help-link__button"
    }, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modal) = $event)),
      onHide: _ctx.onHide,
      "no-header": "",
      "no-padding": ""
    }, {
      default: _withCtx(() => [
        (_ctx.modal)
          ? (_openBlock(), _createElementBlock("video", _hoisted_3, [
              _createElementVNode("source", {
                src: _ctx.url,
                type: "video/mp4"
              }, null, 8, _hoisted_4)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHide"])
  ]))
}